import { useEffect, useState } from 'react';
import { ApiError } from '../../../shared.api';
import { listAuditHistory, type AuditEntryView } from '../history.api';

export type HistoryState = { status: 'loading' } | { status: 'loaded'; entries: AuditEntryView[] } | { status: 'forbidden' } | { status: 'error' };

/** Only fetches while the drawer is open — this is a detail view opened on demand, not a page. */
export function useHistory(entityType: string, entityId: string, open: boolean): HistoryState {
  const [state, setState] = useState<HistoryState>({ status: 'loading' });

  useEffect(() => {
    if (!open) return;
    let cancelled = false;

    listAuditHistory(entityType, entityId)
      .then((entries) => {
        if (!cancelled) setState({ status: 'loaded', entries });
      })
      .catch((err) => {
        if (cancelled) return;
        setState({ status: err instanceof ApiError && err.status === 403 ? 'forbidden' : 'error' });
      });

    return () => {
      cancelled = true;
    };
  }, [entityType, entityId, open]);

  return state;
}
